import React from 'react';
import { Grid } from '@material-ui/core';
import alert from 'core/assets/svg/alert-white-filled.svg';

import { Label } from 'core/components/label';

import useStyles from './imported-policy-footer.styles';

const ImportedPolicyFooter = () => {
  const classes = useStyles();

  return (
    <div className={classes.floatingContainer}>
      <div className={classes.footerContainer}>
        <Grid container justifyContent="flex-start" alignItems="center" className={classes.footerContent}>
          <Grid className={classes.callOut}>
            <img src={alert} alt="Notification Icon" />
            <Grid className={classes.textContainer}>
              <Label className={classes.title} type="subtitleLight">
                This policy was imported and can't be edited.
              </Label>
              <Label className={classes.subtitle}>
                You can review the policy, but you can't make changes or add endorsements.
              </Label>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ImportedPolicyFooter;
